<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}翻倍结算系数
          <span v-show="!this.dataId==0">翻倍结算系数：[{{this.dataId}}]</span>
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  名称
                </th>
                <td>
                  <el-input type="text"    v-model="formData.name" :maxlength="30" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  是否启用
                </th>
                <td>
                  <el-select v-model="formData.usable" style="width: 165px;">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  翻倍结算系数
                </th>
                <td>
                  <el-input v-model="formData.doubleSettleCoefficient" autocomplete="off" clearable
                            style="width: 165px" type="number" min="0" max="1" step="0.01" />
                </td>
                <th>
                  <em class="f-red">*</em>
                  完工方式
                </th>
                <td>
                  <el-select v-model="formData.finishType" style="width: 165px;">
                    <el-option label="总部代完工" :value="1"/>
                    <el-option label="网点PC端完工" :value="2"/>
                    <el-option label="网点APP完工" :value="3"/>
                    <el-option label="师傅APP完工" :value="4"/>
                    <el-option label="接口完工" :value="5"/>
                    <el-option label="其他" :value="9"/>
                  </el-select>
                </td>
              </tr>
              <tr style="position: relative;height: 36px;">
                <th>
                  <em class="f-red">*</em>开始时间
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.beginDate" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>结束时间
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.endDate" clearable/>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
  </div>
</template>
<script>
import {dictType, loadDictData} from "@/config/dictType"
import Tinymce from '@/components/Tinymce';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue';
import api from "@/api/projectApi";
import {fetchTree} from "@/api/admin/type_tree";

export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    preconditionDialog,
    sitePop,

    Tinymce,
  },
  data() {
    return {
      getDataUrl: '/basic/basCompanyDoubleSettleCoefficient/getById',
      addDataUrl: '/basic/basCompanyDoubleSettleCoefficient/add',
      updateDataUrl: '/basic/basCompanyDoubleSettleCoefficient/update',

      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      tenant: {
        status: 0,
        tenantAttachmentDTOs: []
      },


      formData: {
        id: '',  // 主键id,自动新增
        createBy: '',  // 创建人
        createTime: '',  // 创建时间
        name: '',  // 标准名称
        usable: '',  // 是否启用
        finishType : '',  // 完工方式
        doubleSettleCoefficient: '',  // 翻倍结算系数

        beginDate: '',  // 开始时间，注意格式为年月日  yyyy-mm-dd
        endDate: '',  // 结束时间，注意格式为年月日  yyyy-mm-dd
        date: null
      },
    }
  },

  computed: {
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  watch: {

  },
  mounted() {
    this.getData()
  },
  methods: {
    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data || {}
          this.formData = data
        })
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (this.formData.id === null){
          if (this.formData.name === null){
            this.$message.warning('请填写名称')
            return
          }
          if (this.formData.usable === null){
            this.$message.warning('请选择是否启用')
            return
          }
          if (this.formData.finishType === null){
            this.$message.warning('请选择完工方式')
            return
          }
          if (this.formData.beginDate === null){
            this.$message.warning('请选择开始时间')
            return
          }
          if (this.formData.endDate === null){
            this.$message.warning('请选择结束时间')
            return
          }
        }
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            let date = this.formData.date;
            if (date != null && date.length > 0) {
              this.formData.beginDate = date[0]
              this.formData.endDate = date[1]
            }
            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('editViewDataUpdate')
              this.$baseReload()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      })
    },

  },
};

</script>
<style lang="scss" scoped>

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.current-date-picker {
  width: 100%;
  border-radius: 2px;
  border-color: #e8e8e8;
  padding: 0 24px 0 8px;
  height: 28px !important;
  line-height: 28px;
}
.current-date-picker[data-v-b58b35ce] {
    width: 85%!important;
    border-radius: 2px;
    border-color: #e8e8e8;
    padding: 0 0px 0 8px!important;
    height: 28px !important;
    line-height: 28px;
}
</style>
